import { useMutation } from '@tanstack/react-query'

import { Methods } from '@/api/v1/change-invoice-email'
import { aspidaClient } from '@/lib/aspida'
import { MutationConfig } from '@/lib/react-query'
import { queryClient } from '@/lib/react-query'

import { userKeyFactory } from '../user/key'

export type ChangeInvoiceEmailDTO = {
  data: Methods['put']['reqBody']
}

export const changeInvoiceEmail = ({ data }: ChangeInvoiceEmailDTO) => {
  return aspidaClient.v1.change_invoice_email.$put({ body: data })
}

type UseChangeInvoiceEmailOptions = {
  config?: Omit<MutationConfig<typeof changeInvoiceEmail>, 'onSuccess'>
}

export const useChangeInvoiceEmail = ({
  config,
}: UseChangeInvoiceEmailOptions) => {
  return useMutation({
    ...config,
    mutationFn: changeInvoiceEmail,
    onSuccess: () => queryClient.invalidateQueries(userKeyFactory.me()),
  })
}
